export interface props {
	doctorCount: number;
	completedCounsultCount: number;
	consultCount: number;
}

export const TelehealthDashboard = ({
	doctorCount,
	completedCounsultCount,
	consultCount,
}: props) => {
	return (
		<div className="ch-card ch-border p-6 flex flex-row justify-between">
			<div className="flex flex-col w-1/3">
				<div className="ch-em-text">Active Doctors</div>
				<div className="ch-xl-text ch-em-text-navy">{doctorCount}</div>
			</div>
			<div className="flex flex-col w-1/3">
				<div className="ch-em-text">Patients In Queue</div>
				<div className="ch-xl-text ch-em-text-navy">{consultCount}</div>
			</div>
			<div className="flex flex-col w-1/3">
				<div className="ch-em-text">Total Consults</div>
				<div className="ch-xl-text ch-em-text-navy">
					{completedCounsultCount}
				</div>
			</div>
		</div>
	);
};
